<template>
	<div class="card">
        <!-- <md-icon class="icon-2-feedback">sentiment_dissatisfied</md-icon>
        <md-icon class="icon-3-feedback">sentiment_satisfied</md-icon>
        <md-icon class="icon-4-feedback">sentiment_very_satisfied</md-icon> -->
		<div class="card-body d-flex" >
            <div>
                <md-icon v-if="item.mood_level === 1" class="icon-list-1-feedback mr-4">sentiment_very_dissatisfied</md-icon>
                <md-icon v-if="item.mood_level === 2" class="icon-list-2-feedback mr-4">sentiment_dissatisfied</md-icon>
                <md-icon v-if="item.mood_level === 3" class="icon-list-3-feedback mr-4">sentiment_satisfied</md-icon>
                <md-icon v-if="item.mood_level === 4" class="icon-list-4-feedback mr-4">sentiment_very_satisfied</md-icon>
            </div>
            <div>
				<div>
					<div class="d-flex">
						<div>{{ item && item.user.name ? item.user.name : '' }} <span class="text-secondary text-small">({{item && item.user.email ? item.user.email : ''}})</span></div>
						<div v-if="item && item.file_path" @click="openFile(item && item.file_path ? item.file_path : 'none')" class="text-primary text-small pt-1 pointer"><span class="text-white pl-1 pr-1">-</span>{{ $t('File Attachment') }}</div>
						<div class="text-small pt-1 date-feedback mr-3">{{ item.created_at }}</div>
					</div>
					</div>
				<div class="d-flex justify-content-between">
					<div class="sub-title">
						<div v-readMore:490="item.description"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FeedbackList',
	data() {
		return {
			file: null,
		};
	},
	props: {
		item: {
			type: Object,
		},
	},
	methods: {
		emit(type) {
			this.$emit(type, this.item);
		},
		parseFile() {
			if (this.item && this.item.file_path) {
				this.file = this.item && this.item.file_path ? JSON.parse(this.item.file_path) : null;
				return this.file;
				// eslint-disable-next-line
			} else {
				this.file = 'none';
			}
			return this.file;
		},
		openFile(item) {
			window.open(item, '_blank');
		},
	},
	created() {
	},
	computed: {
	},
	watch: {
	},
};
</script>
